import {
    Hashtag,
    IconsContainer,
    PartnersBlock,
    PartnersInfo,
    PartnersSection,
} from "./Partners.styles";
import React from "react";
import ErnestBiesLogo from "../../../components/logos/partners/ErnestBiesLogo/ErnestBiesLogo";
import SectionTitle from "../../../components/section-items/SectionTitle/SectionTitle";
import SectionText from "../../../components/section-items/SectionText/SectionText";
import SectionContainer from "../../../components/section-items/SectionContainer/SectionContainer";
import { PARTNERS_DESCRIPTION } from "../../../utils/info";

const Partners = () => {
    return (
        <PartnersSection id={"partners"}>
            <PartnersInfo>
                <SectionContainer>
                    <SectionTitle color={"white"}>{"PARTNERZY"}</SectionTitle>
                    <SectionText resizable color={"white"}>
                        {PARTNERS_DESCRIPTION}
                    </SectionText>
                    <Hashtag>{"DefyTheLimits"}</Hashtag>
                </SectionContainer>
            </PartnersInfo>
            <PartnersBlock>
                <IconsContainer>
                    <ErnestBiesLogo scale={1.7} style={{ marginBottom: 100 }} />
                </IconsContainer>
            </PartnersBlock>
        </PartnersSection>
    );
};

export default Partners;
